var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_c('panel',{staticClass:"content",attrs:{"title":""},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.__('Sikeres regisztráció.')))])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }